import React, { Component } from "react";

// Libraries
import { motion } from "framer-motion";

// Router
import { withRouter } from "react-router-dom";

// SCSS
import "./ShoveberryModal.scss";

class ShoveberryModal extends Component {
  render() {
    const {
      overlayColor,
      thumbnail,
      title,
      timeTaken,
      totalMoves,
      subTitle,
      showPlayAgain = true,
      actionButtonText = "EXPLORE MORE GAMES",
      actionButtonRedirect,
      showTimeSection = true,
      onSubmit,
      onPlayAgainClicked,
    } = this.props;

    return (
      <motion.div
        className="shoveberry-modal"
        style={{ backgroundColor: overlayColor }}
      >
        <motion.div
          className="shoveberry-modal__main-container"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.5,
            delay: 0,
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.5,
            }}
            className="shoveberry-modal__main-container--thumbnail"
          >
            {thumbnail}
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.5,
            }}
            className="shoveberry-modal__main-container--title"
          >
            {title}
          </motion.p>
          {showTimeSection && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.5,
                delay: 0.5,
              }}
              className="shoveberry-modal__main-container--timer"
            >
              <div className="time-taken">
                <p className="secondary-text">Time Taken</p>
                <p className="primary-text">{timeTaken}</p>
              </div>
              <div className="moves-count">
                <p className="secondary-text">Levels Cleared</p>
                <p className="primary-text">{totalMoves}</p>
              </div>
            </motion.div>
          )}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.5,
            }}
            className="shoveberry-modal__main-container--sub-title"
          >
            {subTitle}
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.5,
            }}
            className="shoveberry-modal__main-container--action-btn"
            onClick={() => {
              actionButtonRedirect
                ? this.props.history.push(actionButtonRedirect)
                : onSubmit();
            }}
          >
            {actionButtonText}
          </motion.div>
          {/* {showPlayAgain && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.5,
                delay: 0.5,
              }}
              className="shoveberry-modal__main-container--play-text"
              onClick={onPlayAgainClicked}
            >
              PLAY AGAIN -{">"}
            </motion.p>
          )} */}
        </motion.div>
      </motion.div>
    );
  }
}
export default withRouter(ShoveberryModal);
